import {toAbsoluteUrl} from '../../../helpers'
import './FallbackView.scss'

export function FallbackView() {
  return (
    <div className='fallback-view' role='status' aria-live='polite'>
      <div className='fallback-view__content'>
        <img
          className='fallback-view__logo'
          src={toAbsoluteUrl('/media/logos/WebCert-logo.png')}
          alt='WebCert logo'
        />
        <div className='fallback-view__status'>
          <span className='spinner-border fallback-view__spinner' aria-hidden='true'></span>
          <span>Loading your page...</span>
        </div>
        <p className='fallback-view__hint'>Thanks for waiting while we prepare the latest data.</p>
      </div>
    </div>
  )
}
